import { mediaData } from '@/mocks/home';

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
          精彩视频
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10 md:mb-12 max-w-xl mx-auto">
          热门影视解说与精彩片段，快速了解影片亮点
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaData.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-lg border border-background-200/60 overflow-hidden cursor-pointer hover:border-primary-200/60 transition-colors group"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/25 flex items-center justify-center group-hover:bg-black/35 transition-colors">
                  <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center">
                    <i className="ri-play-fill text-primary-500 text-xl w-5 h-5 flex items-center justify-center ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/60 text-white text-xs rounded whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-heading font-bold text-foreground-900 mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
                    {item.views}次观看
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}